import React from 'react';

export function SortPriceUp() {
  return (
    <svg
      className='fill-current'
      version='1.1'
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      viewBox='0 0 512.001 512.001'
      xmlSpace='preserve'
      width='20px'
      height='20px'
    >
      <path d='M132.809,497.68v-56.416c-36.64-1.16-73.273-11.664-94.24-25.584l15.704-54.664c27.494,16.29,58.766,25.115,90.72,25.6c36.64,0,61.649-18.032,61.649-45.936c0-26.168-20.36-43.04-63.392-58.745c-38.616-14.832-78.167-42.752-78.167-96.823c0-50.016,34.896-88.4,93.601-98.864V21.976h47.688v54.08c27.85,0.311,55.274,6.872,80.248,19.2l-15.705,53.504c-24.409-12.805-51.526-19.586-79.088-19.776c-40.712,0-55.248,20.936-55.248,40.712c0,23.84,20.936,37.216,70.4,56.992c65.136,24.424,94.208,55.833,94.208,107.585c0,49.432-34.312,93.048-98.28,103.512v59.896L132.809,497.68z' />
      <rect x='389.934' y='127.248' width='15.999' height='384.753' />
      <polygon points='322.448,130.744 397.936,0 473.433,130.744' />
    </svg>
  );
}
